import Skeleton from '@material-ui/lab/Skeleton';
import React, { lazy, Suspense, useEffect, useRef } from 'react';
import { HashRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import Settings from '../controls/wrappers/settings/settingscontainer';
import Alert from '../core/controls/components/alert';
import ConfirmationDialog from '../core/controls/components/confirmationPopup';
import HelpContext from '../core/controls/components/helpContext';
import Loader from '../core/controls/components/loading';
import RecordEditor from '../core/controls/components/recordeditors';
import DefaultSettings from '../core/controls/components/settings';
import Notice from '../controls/wrappers/notice';
import MasterTemplates from '../controls/wrappers/mastertemplate';
import consultantgrid from '../json/consultant/consultantgrid';
import SidebarBr from '../controls/wrappers/sidebarbr';
import Search from '../modules/search/index_tsp';
import billingdashboard from '../billing/billingdashboard';
import InvoiceCycleGrid from '../controls/wrappers/invoicecycles/invoicecyclesgrid';
import Billingconfiguration from '../billing/billingconfiguration';
import Authorizations from '../controls/wrappers/authorizations';
import InvoicePermitRenewals from '../billing/invoicepermitrenewals';
import DownloadAllInvoices from '../billing/downloadallinvoices';
import RegenerateApplicantInvoice from '../billing/regenerateapplicantinvoice';
import Invoicemanagementtabs from '../billing/invoicemanagementtabs';
import usePreviousLocation from './previouslocation';
import Announcements from '../controls/wrappers/announcements/announcementscontainer';


const CreateRecord = lazy(() => import('../controls/wrappers/record/createrecord'));
const EditRecord = lazy(() => import('../controls/wrappers/record/editrecord'));
const CGrid = lazy(() => import('../core/modules/Grid/cgrid'));
const ProjectDownloads = lazy(() => import('../controls/wrappers/projectdownloads/projectdownloadscontainer'));


export default function RouteControls(props) {
    let userProps = {
        'AccessPortal': props.AccessPortal,
        'accessPermissions': props.accessPermissions,
        'accessLevelPermissions': props.accessLevelPermissions
    }
    let compmap = props.compmap
    const helpContext = useRef(null);
    const loaderView = React.useRef(null);
    const alertView = React.useRef(null);
    const noticeView = useRef(null)
    const confirmationView = useRef(null)

    // useEffect(() => {
    //     console.log('Current route:', location.pathname);
    //     console.log('Previous route:', previousLocation ? previousLocation.pathname : 'N/A');
    //     if (location && previousLocation && location.pathname !== previousLocation.pathname) {
    //         setReload(!reload)
    //     }
    // }, [location]);


    useEffect(() => {
        if (loaderView && loaderView.current)
            DefaultSettings.setLoader(loaderView.current);
        if (alertView && alertView.current)
            DefaultSettings.setAlert(alertView.current);
        if (helpContext && helpContext.current)
            DefaultSettings.setDrawer(helpContext.current);
        if (noticeView && noticeView.current)
            DefaultSettings.setNotices(noticeView.current);
        if (confirmationView && confirmationView.current)
            DefaultSettings.setConfirmation(confirmationView.current);

        // Cleanup function
        return () => {
            console.log('Cleaning up RouteControls');

            // Example cleanup logic
            // Reset any state if necessary
            DefaultSettings.setLoader(null);
            DefaultSettings.setAlert(null);
            DefaultSettings.setDrawer(null);
            DefaultSettings.setNotices(null);
            DefaultSettings.setConfirmation(null);
        };
    }, [loaderView, alertView, helpContext, noticeView, confirmationView]);


    return (<Suspense fallback={<div className="col">
        {/* <Backdrop open={true} /> */}
        <Skeleton variant="text" width='100%' height={50} />
        <Skeleton variant="rect" width='100%' height={800} />
    </div>}>
        <>
            <Loader ref={loaderView} />
            <Alert ref={alertView} />
            <HelpContext ref={helpContext} />
            <RecordEditor ref={noticeView} />
            <ConfirmationDialog ref={confirmationView} />
            <Route exact={true} strict path='/Records/:key/new' render={() => <CreateRecord {...userProps} compmap={compmap} />} />
            <Route exact={true} strict path='/Records/:key/:routeid/:routeid1/:sidebar?/:id?' render={() => <EditRecord userProps={userProps} compmap={compmap} />} />
            <Route exact={true} strict path='/Administration/settings/:TableName?' component={Settings} />
            <Route exact={true} strict path='/Administration/noticestypes/:mid?' component={Notice} />
            <Route exact={true} strict path='/Administration/masternotices/:id?' component={MasterTemplates} />
            <Route exact={true} strict path='/Administration/sidebarbr/:id?' component={SidebarBr} />
            <Route exact={true} strict path='/Administration/projectdownloads' component={ProjectDownloads} />
            <Route exact={true} strict path='/search' component={Search} />
            <Route exact={true} strict path='/billingdashboard' component={billingdashboard} />
            <Route exact={true} strict path='/Administration/billingconfiguration/:id?' component={Billingconfiguration} />
            <Route exact={true} strict path='/Administration/invoicepermitrenewals/:id?' component={InvoicePermitRenewals} />
            <Route exact={true} strict path='/Administration/downloadallinvoices/:id?' component={DownloadAllInvoices} />
            <Route exact={true} strict path='/Administration/regenerateapplicantinvoice/:id?' component={RegenerateApplicantInvoice} />
            <Route exact={true} strict path='/Administration/invoicemanagementtabs/:id?' component={Invoicemanagementtabs} />
            <Route exact={true} strict path='/Administration/invoicecycles/:Id?' component={InvoiceCycleGrid} />
            <Route exact={true} strict path='/Administration/authorizations/:id?' component={Authorizations} />
            <Route exact={true} strict path='/Administration/announcements/:id?' component={Announcements} />
            <Route exact={true} strict path='/Administration/consultants/:Id?' render={() => <CGrid compmap={compmap} components={props.components}
                {...userProps} {...consultantgrid} />} />
            {/* Spread the contentcomp array into the Switch */}
            {/* {[...props.contentcomp]} */}
        </>
    </Suspense>
    );
}